import { Link } from "react-router-dom";
import logo from "@/assets/qa1st-logo.webp";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container-narrow px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <img src={logo} alt="QA 1st" className="h-10 w-10 rounded object-cover" />
              <h3 className="text-lg font-bold text-primary-foreground">QA 1st</h3>
            </div>
            <p className="text-primary-foreground/70 text-sm max-w-md">
              Quality and assurance for the AI era. We help training providers, Awarding &amp; Assessment Organisations and businesses strengthen quality, govern AI responsibly and introduce new technology with confidence.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-primary-foreground mb-3 text-sm">Who we help</h4>
            <ul className="space-y-2 text-sm">
              {[
                { label: "Training Providers", path: "/training-providers" },
                { label: "Awarding & Assessment Organisations", path: "/awarding-organisations" },
                { label: "Businesses & SMEs", path: "/ai-for-business" },
                { label: "Ofsted Reports", path: "/ofsted-reports" },
                { label: "Case Studies", path: "/case-studies" },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-primary-foreground/70 hover:text-accent transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="font-semibold text-primary-foreground mb-3 text-sm">Explore</h4>
            <ul className="space-y-2 text-sm">
              {[
                { label: "Services", path: "/services" },
                { label: "AI Leadership Accelerator", path: "/ai-leadership-accelerator" },
                { label: "Insights", path: "/blog" },
                { label: "About", path: "/about" },
                { label: "Contact", path: "/contact" },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-primary-foreground/70 hover:text-accent transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <div className="border-t border-primary-foreground/10 mt-10 pt-6 flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <ul className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-primary-foreground/60">
            {[
              { label: "Privacy Policy", path: "/privacy" },
              { label: "Cookie Policy", path: "/cookies" },
              { label: "AI Transparency", path: "/ai-transparency" },
              { label: "Terms of Use", path: "/terms" },
              { label: "Accessibility", path: "/accessibility" },
            ].map((link) => (
              <li key={link.path}>
                <Link to={link.path} className="hover:text-accent transition-colors">
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
          <p className="text-center text-xs text-primary-foreground/50">
            © {new Date().getFullYear()} QA 1st. All rights reserved.
          </p>
        </div>

      </div>
    </footer>
  );
};

export default Footer;
